import React from "react";
import { useTranslation } from "react-i18next";

export default function CustomerTabs({ tabs, activeTab, setActiveTab }: any) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap gap-2 border-b border-LightGrey3">
      {tabs.map((tab: any) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`px-4 py-2 rounded-t-xl transition text-sm font-medium ${
            activeTab === tab.id
              ? "bg-primary text-white"
              : "text-muted hover:text-Black"
          }`}
        >
          {t(tab.label)}
        </button>
      ))}
    </div>
  );
}
